import { GROUP_PERMISSIONS, ORGANIZATION_DATA_SOURCES, ORGANIZATION_PERMISSIONS, PERMISSION_LABELS } from '@/constants';

export const getDefaultPermissions = permissions =>
  Object.keys(permissions)
    .sort((a, b) => permissions[b] - permissions[a])
    .map(key => ({
      key,
      value: false,
    }));

export const getPermissionLabels = () =>
  Object.keys(PERMISSION_LABELS)
    .sort((a, b) => b - a)
    .map(key => PERMISSION_LABELS[key]);

export const getDefaultOrgPermissions = () => getDefaultPermissions(ORGANIZATION_PERMISSIONS);

export const getDefaultGroupPermissions = () => getDefaultPermissions(GROUP_PERMISSIONS);

export const getEmptyGroup = () => ({
  id: null,
  name: null,
  permissions: getDefaultPermissions(GROUP_PERMISSIONS),
});

export const getEmptyOrganization = () => ({
  id: null,
  name: null,
  permissions: getDefaultPermissions(ORGANIZATION_PERMISSIONS),
  groups: [getEmptyGroup()],
});

/**
 * Checks if an organization is a Voxy internal organization
 * @param {Object} organization - The organization object to check
 * @returns {boolean} True if the organization's data_source is voxy_internal
 */
export const isOrgInternal = organization => {
  return !!(organization && organization.data_source === ORGANIZATION_DATA_SOURCES.VOXY_INTERNAL);
};

/**
 * Checks if a learner belongs to a Voxy internal organization
 * @param {Object} learner - The learner object to check
 * @returns {boolean} True if the learner's organization is voxy_internal
 */
export const isLearnerOrgInternal = learner => {
  return learner && learner.organization ? isOrgInternal(learner.organization) : false;
};
